/* eslint-disable  */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";

const Dashboard = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState(null);
  const user = window.CURRENT_USER;

  const company = window.COMPANY;
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const response = await fetch("/payments/api/analytics/");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAnalytics(data);
      } catch (error) {
        console.error("Error fetching analytics:", error);
      }
    };
    fetchAnalytics();
  }, []);
  useEffect(() => {
    const url =
      user?.user_role === "customer"
        ? `/dashboard/analytics/?id={company.currency_symbol}{" "}{user?.customer_id}`
        : "/dashboard/analytics/";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setData(data);
      })
      .catch((err) => {
        console.error("Failed to fetch analytics:", err);
      });
  }, []);

  return (
    <>
      <div
        className={`main-wrapper {company.currency_symbol}{" "}{menu ? "slide-nav" : ""}`}
      >
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-1">
                        <i className="fas fa-dollar-sign"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Funds</div>
                        <div className="dash-counts">
                          <p>
                            {company.currency_symbol} {analytics?.total_funds}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-5"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-2">
                        <i className="fas fa-credit-card"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Payment</div>
                        <div className="dash-counts">
                          <p>
                            {company.currency_symbol}{" "}
                            {analytics?.total_payments}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-6"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-3">
                        <i className="fas fa-hand-holding-usd"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Advance Payment</div>
                        <div className="dash-counts">
                          <p>
                            {company.currency_symbol}{" "}
                            {analytics?.advance_payments}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-7"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-4">
                        <i className="fas fa-receipt"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Expenses</div>
                        <div className="dash-counts">
                          <p>
                            {company.currency_symbol}{" "}
                            {analytics?.total_expenses}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-8"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-2">
                        <i className="fas fa-users"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Customers</div>
                        <div className="dash-counts">
                          <p>{data?.total_customer}</p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-6"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-3">
                        <i className="fas fa-file-alt"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Invoices</div>
                        <div className="dash-counts">
                          <p>{data?.total_invoices}</p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-7"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-4">
                        <i className="far fa-file"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Quotation</div>
                        <div className="dash-counts">
                          <p>{data?.invoice_quote_len}</p>
                        </div>
                      </div>
                    </div>
                    <div className="progress progress-sm mt-3">
                      <div
                        className="progress-bar bg-8"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Recent Invoices</h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/invoice/"
                          className="btn-right btn btn-sm btn-outline-primary"
                          disabled={data?.recent_invoices?.length === 0}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.recent_invoices.map((item, index) => {
                            let status;
                            if (item.status.label === "Paid") {
                              status = (
                                <span className="badge bg-success-light">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Quote") {
                              status = (
                                <span className="badge bg-info-light text-info">
                                  {item.status.label}
                                </span>
                              );
                            } else if (
                              item.status.label === "Proforma Invoice"
                            ) {
                              status = (
                                <span className="badge bg-info-light text-info">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Unpaid") {
                              status = (
                                <span className="badge bg-warning-light text-warning">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Overdue") {
                              status = (
                                <span className="badge bg-danger-light">
                                  {item.status.label}
                                </span>
                              );
                            }
                            console.log("item", item);

                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    {item.customer.user.full_name}
                                  </h2>
                                </td>
                                <td>
                                  {company?.currency_symbol}{" "}
                                  {item?.total_invoice_amount}
                                </td>
                              </tr>
                            );
                          })}
                          {data?.recent_invoices?.length === 0 && (
                            <tr>
                              <td> No Data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Recent Estimates</h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/invoice?status=5"
                          className="btn-right btn btn-sm btn-outline-primary"
                          disabled={data?.recent_quotes?.length === 0}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Expiry Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.recent_quotes?.map((item, index) => {
                            let status;
                            if (item.status.label === "Paid") {
                              status = (
                                <span className="badge bg-success-light">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Quote") {
                              status = (
                                <span className="badge bg-info-light text-info">
                                  {item.status.label}
                                </span>
                              );
                            } else if (
                              item.status.label === "Proforma Invoice"
                            ) {
                              status = (
                                <span className="badge bg-info-light text-info">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Unpaid") {
                              status = (
                                <span className="badge bg-warning-light text-warning">
                                  {item.status.label}
                                </span>
                              );
                            } else if (item.status.label === "Overdue") {
                              status = (
                                <span className="badge bg-danger-light">
                                  {item.status.label}
                                </span>
                              );
                            }

                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/profile">
                                      {item.customer.user.full_name}
                                    </Link>
                                  </h2>
                                </td>
                                <td>{company?.currency_symbol}{" "} {item?.total_invoice_amount}</td>
                                <td>{item.due_formatted_date}</td>
                                <td>{status}</td>
                              </tr>
                            );
                          })}
                          {data?.recent_quotes?.length === 0 && (
                            <tr>
                              <td> No Data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
